/* ============================================================
   LEDFROST — storefront
   ============================================================ */
(function () {
  'use strict';

  var cfgEl = document.getElementById('lf-data');
  var CFG = {};
  try { CFG = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { CFG = {}; }

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents, cur) {
    var c = cur || CFG.currency || 'EUR';
    var v = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(CFG.locale || 'fr', { style: 'currency', currency: c }).format(v);
    } catch (e) {
      return v.toFixed(2) + ' ' + c;
    }
  }

  /* ---------------- reveal on scroll ---------------- */
  (function reveal() {
    var els = $$('.lf-rev');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -7% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ---------------- marquee : duplicate the run ---------------- */
  $$('[data-lf-mq]').forEach(function (mq) {
    var run = mq.querySelector('[data-run]');
    if (run) run.parentNode.appendChild(run.cloneNode(true));
  });

  /* ---------------- header ---------------- */
  (function header() {
    var hd = $('[data-lf-hd]');
    if (!hd) return;
    var onScroll = function () { hd.classList.toggle('is-stuck', window.scrollY > 24); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var burger = $('[data-lf-burger]');
    var menu = $('[data-lf-mobmenu]');
    if (burger && menu) {
      burger.addEventListener('click', function () { menu.classList.toggle('is-open'); });
    }
  })();

  /* ---------------- countdown ---------------- */
  $$('[data-lf-cd]').forEach(function (el) {
    var raw = el.getAttribute('data-end');
    if (!raw) return;
    var end = new Date(raw.replace(' ', 'T')).getTime();
    if (isNaN(end)) return;
    var bar = el.closest('[data-lf-promo]');
    var L = CFG.cd || { d: 'J', h: 'H', m: 'MIN', s: 'SEC' };

    function unit(n, l) {
      return '<span class="lf-cd__u"><span class="lf-cd__n">' +
        String(n).padStart(2, '0') + '</span><span class="lf-cd__l">' + l + '</span></span>';
    }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { if (bar) bar.remove(); clearInterval(t); return; }
      var s = Math.floor(left / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;
      el.innerHTML = (d > 0 ? unit(d, L.d) : '') + unit(h, L.h) + unit(m, L.m) + unit(s, L.s);
    }
    tick();
    var t = setInterval(tick, 1000);
  });

  /* ---------------- snow on the hero ---------------- */
  (function snow() {
    var host = $('[data-lf-snow]');
    if (!host) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var cv = document.createElement('canvas');
    cv.style.cssText = 'position:absolute;inset:0;width:100%;height:100%';
    host.appendChild(cv);
    var ctx = cv.getContext('2d');
    var flakes = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2);

    function size() {
      var r = host.getBoundingClientRect();
      w = r.width; h = r.height;
      if (!w || !h) return;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(150, (w * h) / 11000));
      flakes = [];
      for (var i = 0; i < n; i++) {
        flakes.push({
          x: Math.random() * w, y: Math.random() * h,
          r: Math.random() * 2.1 + 0.5,
          vy: Math.random() * 0.55 + 0.22,
          vx: Math.random() * 0.4 - 0.2,
          a: Math.random() * 0.5 + 0.22,
          p: Math.random() * Math.PI * 2
        });
      }
    }

    var raf;
    function draw() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < flakes.length; i++) {
        var f = flakes[i];
        f.p += 0.014;
        f.y += f.vy;
        f.x += f.vx + Math.sin(f.p) * 0.35;
        if (f.y > h + 6) { f.y = -6; f.x = Math.random() * w; }
        if (f.x > w + 6) f.x = -6;
        if (f.x < -6) f.x = w + 6;
        ctx.beginPath();
        ctx.arc(f.x, f.y, f.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(226,244,255,' + f.a + ')';
        ctx.fill();
      }
      raf = requestAnimationFrame(draw);
    }

    size();
    draw();
    window.addEventListener('resize', size);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { cancelAnimationFrame(raf); } else { raf = requestAnimationFrame(draw); }
    });
  })();

  /* ---------------- before / after ---------------- */
  $$('[data-lf-ba]').forEach(function (ba) {
    var dragging = false;
    function set(pct) {
      pct = Math.max(0, Math.min(100, pct));
      ba.style.setProperty('--pos', pct + '%');
      var knob = ba.querySelector('.lf-ba__knob');
      if (knob) knob.setAttribute('aria-valuenow', Math.round(pct));
    }
    function from(e) {
      var r = ba.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    }
    ba.addEventListener('pointerdown', function (e) { dragging = true; ba.setPointerCapture(e.pointerId); from(e); });
    ba.addEventListener('pointermove', function (e) { if (dragging) from(e); });
    ba.addEventListener('pointerup', function () { dragging = false; });
    ba.addEventListener('pointercancel', function () { dragging = false; });
    ba.addEventListener('keydown', function (e) {
      var cur = parseFloat(ba.style.getPropertyValue('--pos')) || 50;
      if (e.key === 'ArrowLeft')  { set(cur - 4); e.preventDefault(); }
      if (e.key === 'ArrowRight') { set(cur + 4); e.preventDefault(); }
    });
  });

  /* ---------------- colour swatches ---------------- */
  (function colours() {
    var wrap = $('[data-lf-colours]');
    if (!wrap) return;
    var glow = $('[data-lf-glow]', wrap);
    var name = $('[data-lf-colname]', wrap);
    var btns = $$('button[data-c]', wrap);

    function pick(b) {
      btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      var c = b.getAttribute('data-c');
      if (glow) glow.style.setProperty('--c', c);
      if (name) name.textContent = b.getAttribute('data-n') || '';
    }
    btns.forEach(function (b) {
      b.style.background = b.getAttribute('data-c');
      b.style.color = b.getAttribute('data-c');
      b.addEventListener('click', function () { pick(b); });
    });
    if (btns.length) pick(btns[0]);
  })();

  /* ---------------- FAQ ---------------- */
  $$('[data-lf-faq]').forEach(function (list) {
    list.addEventListener('click', function (e) {
      var btn = e.target.closest('.lf-q__b');
      if (!btn) return;
      var open = btn.getAttribute('aria-expanded') === 'true';
      $$('.lf-q__b', list).forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.nextElementSibling.style.height = '0px';
      });
      if (!open) {
        btn.setAttribute('aria-expanded', 'true');
        var p = btn.nextElementSibling;
        p.style.height = p.scrollHeight + 'px';
      }
    });
  });

  /* ---------------- reviews carousel ---------------- */
  (function reviews() {
    var vp = $('[data-lf-rvvp]');
    if (!vp) return;
    var tr = $('[data-lf-rvtr]', vp);
    var cards = $$('.lf-rv__c', tr);
    if (!cards.length) return;
    var i = 0, timer;

    function per() { return window.innerWidth <= 760 ? 1 : (window.innerWidth <= 1000 ? 2 : 3); }
    function max() { return Math.max(0, cards.length - per()); }
    function go() {
      i = Math.min(i, max());
      var step = cards[0].getBoundingClientRect().width + 20;
      tr.style.transform = 'translateX(' + (-i * step) + 'px)';
    }
    var prev = $('[data-lf-rvprev]'), next = $('[data-lf-rvnext]');
    if (prev) prev.addEventListener('click', function () { i = i > 0 ? i - 1 : max(); go(); });
    if (next) next.addEventListener('click', function () { i = i < max() ? i + 1 : 0; go(); });
    window.addEventListener('resize', go);
    go();
    timer = setInterval(function () { i = i < max() ? i + 1 : 0; go(); }, 6500);
    vp.addEventListener('mouseenter', function () { clearInterval(timer); });
  })();

  /* ---------------- pack selector ---------------- */
  $$('[data-lf-packs]').forEach(function (wrap) {
    var btns = $$('[data-pack]', wrap);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var t = document.querySelector(b.getAttribute('data-target') || '');
        if (t) {
          t.setAttribute('data-qty', b.getAttribute('data-qty') || '1');
          var lbl = t.querySelector('[data-lf-addlabel]');
          if (lbl && b.getAttribute('data-label')) lbl.textContent = b.getAttribute('data-label');
        }
      });
    });
    var on = wrap.querySelector('.is-on') || btns[0];
    if (on) on.click();
  });

  /* ---------------- cart ---------------- */
  var cart = {
    el: null,
    open: function () {
      if (!this.el) this.el = $('[data-lf-cart]');
      if (!this.el) { window.location.href = '/cart'; return; }
      this.el.hidden = false;
      document.body.style.overflow = 'hidden';
      this.refresh();
    },
    close: function () {
      if (!this.el) this.el = $('[data-lf-cart]');
      if (!this.el) return;
      this.el.hidden = true;
      document.body.style.overflow = '';
    },
    refresh: function () {
      var self = this;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.render(c); 
          /* delivery options (protection, priority) are not counted as articles */
          var box = $('[data-lf-addons]'), ids = box ? (box.getAttribute('data-ids') || '').split(',') : [];
          self.badge(c.items.reduce(function (n, it) { return ids.indexOf(String(it.variant_id)) > -1 ? n : n + it.quantity; }, 0)); })
        .catch(function () {});
    },
    badge: function (n) {
      $$('[data-lf-count]').forEach(function (b) {
        b.textContent = n;
        b.hidden = !n;
        if (n) {
          b.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.4)' }, { transform: 'scale(1)' }],
            { duration: 320, easing: 'ease-out' });
        }
      });
    },
    render: function (c) {
      var body = $('[data-lf-cartbody]');
      var foot = $('[data-lf-carttotal]');
      if (!body) return;
      if (!c.items.length) {
        var T2 = {}; try { T2 = JSON.parse((document.getElementById('lf-t2') || {}).textContent || '{}'); } catch (e) {}
        body.innerHTML = '<div class="pn-empty"><p>' + (CFG.t_empty || 'Votre panier est vide.') + '</p>' +
          '<a href="' + (body.getAttribute('data-shop-url') || '/') + '#acheter" class="pn-empty__a" data-lf-close>' + (T2.empty_cta || 'Découvrir les LED') + '</a></div>';
        if (foot) foot.textContent = money(0, c.currency);
        return;
      }
      /* LED packs first, accessories after */
      var sorted = c.items.slice().sort(function (a, b) { return (b.handle === 'woofgolf-caddy-costume') - (a.handle === 'woofgolf-caddy-costume'); });
      /* Halloween : compare-at prices of the packs, to show the struck price and the total saved */
      var CMP = {}; try { CMP = JSON.parse(body.getAttribute('data-cmp') || '{}'); } catch (e) {}
      var saved = 0;
      body.innerHTML = sorted.map(function (it) {
        var cmpLine = (CMP[it.variant_id] || 0) * it.quantity;
        if (cmpLine > it.final_line_price) saved += cmpLine - it.final_line_price; else cmpLine = 0;
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        return '<div class="lf-li">' +
          '<img src="' + img + '" alt="" loading="lazy" width="72" height="72">' +
          '<div class="lf-li__t"><b>' + it.product_title + '</b>' +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + it.variant_title + '</small>' : '') +
          ((it.line_level_discount_allocations || []).filter(function (d) { return d.amount > 0; }).map(function (d) {
            return '<small class="lf-li__deal">' + ((d.discount_application && d.discount_application.title) || '') + ' · −' + money(d.amount, c.currency) + '</small>';
          }).join('')) +
          '<div class="pn-qty" role="group" aria-label="' + (CFG.t_qty || 'Qté') + '">' +
            '<button type="button" data-pn-q="' + it.key + '" data-q="' + (it.quantity - 1) + '" aria-label="−">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-pn-q="' + it.key + '" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button>' +
          '</div></div>' +
          '<div class="lf-li__p">' + (cmpLine ? '<s>' + money(cmpLine, c.currency) + '</s>' : '') + '<b>' + money(it.final_line_price, c.currency) + '</b>' +
          '<button type="button" class="lf-li__rm" data-lf-rm="' + it.key + '" aria-label="' + (CFG.t_remove || 'Retirer') + '">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 7h14M10 7V5h4v2M7 7l1 12h8l1-12"/></svg></button></div>' +
          '</div>';
      }).join('');
      if (foot) foot.textContent = money(c.total_price, c.currency);
      $$('[data-pn-cartsave]').forEach(function (r) {
        r.hidden = !saved;
        var v = r.querySelector('[data-pn-cartsave-v]'); if (v) v.textContent = '−' + money(saved, c.currency);
      });

      var ship = $('[data-lf-shipbar]');
      if (ship) {
        var goal = CFG.free_ship || 0;
        if (goal > 0) {
          var pct = Math.min(100, (c.total_price / goal) * 100);
          ship.querySelector('i').style.width = pct + '%';
          var txt = ship.parentElement.querySelector('[data-lf-shiptxt]');
          if (txt) {
            txt.innerHTML = c.total_price >= goal
              ? '<b>Livraison offerte débloquée</b>'
              : 'Plus que <b>' + money(goal - c.total_price) + '</b> pour la livraison offerte';
          }
        }
      }
    },
    add: function (id, qty, extras) {
      var self = this;
      var items = [{ id: Number(id), quantity: Number(qty) || 1 }];
      (extras || []).forEach(function (x) { if (x) items.push({ id: Number(x), quantity: 1 }); });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function () { self.open(); });
    }
  };

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-lf-open]');
    if (openBtn) { e.preventDefault(); cart.open(); return; }

    var closeBtn = e.target.closest('[data-lf-close]');
    if (closeBtn) { if (closeBtn.tagName !== 'A') e.preventDefault(); cart.close(); return; }

    var qb = e.target.closest('[data-pn-q]');
    if (qb) {
      e.preventDefault();
      var li = qb.closest('.lf-li'); if (li) li.classList.add('is-busy');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: qb.getAttribute('data-pn-q'), quantity: Math.max(0, Number(qb.getAttribute('data-q')) || 0) })
      }).then(function () { cart.refresh(); }).catch(function () { cart.refresh(); });
      return;
    }

    var rm = e.target.closest('[data-lf-rm]');
    if (rm) {
      e.preventDefault();
      var upd = {}; upd[rm.getAttribute('data-lf-rm')] = 0;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: upd })
      }).then(function () { cart.refresh(); });
      return;
    }

    var add = e.target.closest('[data-lf-add]');
    if (add) {
      e.preventDefault();
      var id = add.getAttribute('data-lf-add');
      if (!id || id === '0') { window.location.href = add.getAttribute('data-url') || '/collections/all'; return; }
      var lbl = add.querySelector('[data-lf-addlabel]') || add;
      var prev = lbl.textContent;
      lbl.textContent = CFG.t_adding || 'Ajout…';
      cart.add(id, add.getAttribute('data-qty') || 1, (add.getAttribute('data-extras') || '').split(',')).then(function () {
        lbl.textContent = prev;
      }).catch(function () { lbl.textContent = prev; });
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cart.close(); });
  cart.refresh();

  /* ---------------- sticky bar ---------------- */
  (function sticky() {
    var bar = $('[data-lf-sticky]');
    if (!bar) return;
    var trigger = $('[data-lf-stickyafter]') || $('.lf-hero');
    if (!trigger) return;
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-on'); return; }
    new IntersectionObserver(function (en) {
      bar.classList.toggle('is-on', !en[0].isIntersecting);
    }, { threshold: 0 }).observe(trigger);
  })();

  /* ---------------- newsletter inline forms ---------------- */
  $$('form.lf-form').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var input = f.querySelector('input[type="email"]');
      var msg = f.querySelector('[data-lf-nlmsg]') ||
                (f.parentElement && f.parentElement.querySelector('[data-lf-nlmsg]'));
      var v = (input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
        e.preventDefault();
        if (msg) { msg.className = 'lf-msg err'; msg.textContent = CFG.t_invalid || 'Cette adresse ne semble pas valide.'; }
        input.focus();
      }
    });
  });

  /* ---------------- 15s popup ---------------- */
  (function popup() {
    var pop = $('[data-lf-pop]');
    if (!pop) return;
    var KEY = 'lf_pop_v1';
    var posted = pop.getAttribute('data-posted') === '1';
    var seen = false;
    try { seen = localStorage.getItem(KEY) === '1'; } catch (err) { seen = false; }
    if (seen && !posted) return;

    var delay = posted ? 0 : Number(pop.getAttribute('data-delay') || 15) * 1000;
    var shown = false;

    function mark() { try { localStorage.setItem(KEY, '1'); } catch (err) {} }
    function show() {
      if (shown) return;
      shown = true;
      pop.hidden = false;
      document.body.style.overflow = 'hidden';
      var f = pop.querySelector('input[type="email"]');
      if (f) setTimeout(function () { f.focus(); }, 320);
    }
    function hide() {
      pop.hidden = true;
      document.body.style.overflow = '';
      mark();
    }

    if (delay === 0) { show(); } else { setTimeout(show, delay); }

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-lf-popclose]') || e.target.classList.contains('lf-pop__ov')) hide();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) hide(); });

    var form = pop.querySelector('form');
    if (form) {
      form.addEventListener('submit', function (e) {
        var input = form.querySelector('input[type="email"]');
        var v = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)) {
          e.preventDefault();
          var m = pop.querySelector('[data-lf-popmsg]');
          if (m) { m.className = 'lf-msg err'; m.textContent = CFG.t_invalid || 'Cette adresse ne semble pas valide.'; }
          input.focus();
          return;
        }
        mark();
      });
    }
  })();
})();
